/* eslint-disable spire/export-styles */
import AddedToCartModal from "@iewcasia/Components/AddedToCartModal";
import AddToListModal from "@iewcasia/Components/AddToListModal";
import ShareListModal from "@iewcasia/Components/ShareListModal";
import InventoryResultsModal from "@iewcasia/Widgets/VerndaleBox/InventoryResultsModal";
import SpoolModal from "@iewcasia/Widgets/VerndaleBox/SpoolModal";
import ManageShareListModal from "@insite/content-library/Components/ManageShareListModal";
import ProductDeliveryScheduleModal from "@insite/content-library/Components/ProductDeliveryScheduleModal";
import ProductSelectorVariantModal from "@insite/content-library/Components/ProductSelectorVariantModal";
import ShareListDetailModal from "@insite/content-library/Components/ShareListDetailModal";

import * as React from "react";

interface OwnProps {
    skipInventoryValidation?: boolean;
    skipProductPrice?: boolean;
}

type Props = OwnProps;

const Modals = ({ skipInventoryValidation, skipProductPrice }: Props) => (
    <>
        <ManageShareListModal />
        <ShareListDetailModal />
        <ProductSelectorVariantModal
            skipInventoryValidation={skipInventoryValidation}
            skipProductPrice={skipProductPrice}
        />
        <ProductDeliveryScheduleModal />
        {/* Verndale Customization */}
        <AddToListModal />
        <ShareListModal />
        <InventoryResultsModal />
        <SpoolModal />
        <AddedToCartModal />
    </>
);

export default Modals;
